import { motion } from 'framer-motion';
import { useParams, Link } from 'react-router-dom';

const services = [
  {
    id: 'documentary-films',
    title: 'Documentary Films',
    description: 'At SAMFREN OJO MEDIA, our documentaries spotlight real lives, untold stories, and marginalized voices across Africa. We bring depth, emotion, and authenticity to every story — from personal journeys to social impact narratives — capturing the beauty and complexity of human experience.',
    icon: '🎥',
    features: [
      'In-depth research and development',
      'Cinematic storytelling',
      'Interview coordination',
      'Location scouting',
      'Post-production and editing'
    ],
    detailedDescription: 'Our documentary filmmaking service is dedicated to crafting compelling narratives that resonate with audiences. We specialize in creating thought-provoking content that combines journalistic integrity with cinematic excellence. From initial concept development to final edit, we handle every aspect of production with meticulous attention to detail.',
    process: [
      'Pre-production planning and research',
      'Script development and storyboarding',
      'Cinematic filming with professional equipment',
      'Professional editing and color grading',
      'Sound design and music composition',
      'Final delivery in multiple formats'
    ],
    benefits: [
      'Raise awareness about important issues',
      'Engage and educate your audience',
      'Build credibility and trust',
      'Create lasting impact',
      'Reach wider audiences through film festivals and distribution'
    ],
    image: 'https://images.unsplash.com/photo-1485846234645-a62644f84728?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2059&q=80'
  },
  {
    id: 'events-and-corporate-films',
    title: 'Events & Corporate Films',
    description: 'We cover weddings, conferences, NGO programs, and other events with creative precision and storytelling flair. We document the moments that deserve to live forever.',
    icon: '🎬',
    features: [
      'Event coverage',
      'Multi-camera setup',
      'Live streaming',
      'Highlight reels',
      'Corporate interviews'
    ],
    detailedDescription: 'Our corporate video production service helps businesses communicate their message effectively through professional video content. Whether you need promotional videos, training materials, or company profiles, we create high-quality videos that reflect your brand and engage your target audience.',
    process: [
      'Consultation and concept development',
      'Scriptwriting and storyboarding',
      'Professional filming on location or in-studio',
      'Professional editing and motion graphics',
      'Voice-over recording and sound design',
      'Final delivery in multiple formats'
    ],
    benefits: [
      'Enhance your corporate communication',
      'Showcase your products and services',
      'Train and onboard employees effectively',
      'Boost your online presence',
      'Increase engagement on social media'
    ],
    image: 'https://images.unsplash.com/photo-1523580494863-6f3031224c94?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
  },
  {
    id: 'music-videos',
    title: 'Music Videos',
    description: 'We create original music videos that match your sound with cinematic visuals. From the concept to execution, we bring your song to life with storytelling and crisp editing that feels global.',
    icon: '🎵',
    features: [
      'Concept development',
      'Location scouting',
      'Choreography coordination',
      'Professional lighting and sound',
      'Color grading and post-production'
    ],
    detailedDescription: 'Our music video production service is designed to bring your music to life through captivating visuals. We work closely with artists to create unique concepts that complement their sound and style. From intimate acoustic performances to high-energy dance numbers, we have the expertise to execute your vision.',
    process: [
      'Creative consultation and concept development',
      'Location scouting and set design',
      'Professional filming with cinematic equipment',
      'Choreography and performance direction',
      'Professional editing and visual effects',
      'Color grading and sound mixing'
    ],
    benefits: [
      'Enhance your music with powerful visuals',
      'Reach new audiences on video platforms',
      'Build your brand as an artist',
      'Create shareable content for social media',
      'Stand out in the music industry'
    ],
    image: 'https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
  },
  {
    id: 'real-estate-shoots',
    title: 'Real Estate Shoots',
    description: 'We help developers, agents, and property owners showcase their listings with visually compelling property videos. From architectural shots to lifestyle edits, we turn your spaces into visual experiences buyers can’t ignore.',
    icon: '🏠',
    features: [
      'Aerial drone footage',
      'Virtual tours',
      'Twilight photography',
      'Floor plan visualization',
      'Professional editing'
    ],
    detailedDescription: 'Our real estate media services help property professionals showcase listings in the best possible light. We use professional photography, videography, and drone footage to create compelling visual content that attracts potential buyers and renters.',
    process: [
      'Property consultation and planning',
      'Professional photography and videography',
      'Aerial drone footage (where applicable)',
      'Virtual tour creation',
      'Professional editing and enhancement',
      'Quick turnaround for time-sensitive listings'
    ],
    benefits: [
      'Showcase properties in their best light',
      'Attract more potential buyers',
      'Reduce time on market',
      'Stand out from competitors',
      'Professional presentation of your listings'
    ],
    image: 'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
  },
  {
    id: 'commercial-and-product-videos',
    title: 'Commercial & Product Videos',
    description: 'We produce commercial campaigns, product highlights, and promotional videos that captivate audiences and elevate brands. From script to screen, we craft compelling visuals that help businesses grow and connect with their market.',
    icon: '📢',
    features: [
      'Scriptwriting',
      'Talent coordination',
      'Motion graphics',
      'Voice-over recording',
      'Multi-platform optimization'
    ],
    detailedDescription: 'Our commercial and product video production service helps businesses showcase their products and services in the most compelling way possible. We create engaging, high-quality videos that drive sales and increase brand awareness.',
    process: [
      'Creative strategy and concept development',
      'Scriptwriting and storyboarding',
      'Professional filming with high-end equipment',
      'Professional editing and motion graphics',
      'Voice-over recording and sound design',
      'Optimization for various platforms'
    ],
    benefits: [
      'Increase product awareness and sales',
      'Improve conversion rates',
      'Enhance your digital marketing efforts',
      'Showcase product features effectively',
      'Create shareable content for social media'
    ],
    image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
  },
  {
    id: 'post-production',
    title: 'Post-Production',
    description: 'We transform raw footage into polished, professional content. Whether you need basic editing or complex visual effects, our team of experienced editors will ensure your project meets the highest standards of quality.',
    icon: '🎞️',
    features: [
      'Video editing',
      'Color correction & grading',
      'Sound design & mixing',
      'Visual effects',
      'Motion graphics'
    ],
    detailedDescription: 'Our post-production service transforms raw footage into polished, professional content. Whether you need basic editing or complex visual effects, our team of experienced editors will ensure your project meets the highest standards of quality.',
    process: [
      'Footage organization and review',
      'Rough cut and assembly',
      'Fine editing and pacing',
      'Color correction and grading',
      'Sound design and mixing',
      'Visual effects and motion graphics',
      'Final review and delivery'
    ],
    benefits: [
      'Professional polish for your footage',
      'Consistent look and feel',
      'Enhanced visual and audio quality',
      'Faster turnaround times',
      'Expertise in various editing styles'
    ],
    image: 'https://images.unsplash.com/photo-1432888622747-4eb9a8efeb07?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2052&q=80'
  }
];

const ServiceDetail = () => {
  const { serviceId } = useParams<{ serviceId: string }>();
  const service = services.find(s => s.id === serviceId);

  if (!service) {
    return (
      <div className="min-h-screen pt-32 text-center">
        <h1 className="text-4xl font-bold text-white mb-4">Service Not Found</h1>
        <Link to="/services" className="text-burnt-orange hover:underline">
          Back to Services
        </Link>
      </div>
    );
  }

  return (
    <div className="min-h-screen pt-24">
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-r from-dark-gray to-gray-900">
        <div className="absolute inset-0 overflow-hidden">
          <img 
            src={service.image} 
            alt={service.title} 
            className="w-full h-full object-cover opacity-20"
          />
        </div>
        <div className="container mx-auto px-4 text-center relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="text-6xl mb-4">{service.icon}</div>
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
              {service.title}
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              {service.description}
            </p>
          </motion.div>
          
          {/* Back to Services Button */}
          <div className="mt-8 text-center">
            <Link 
              to="/services" 
              className="inline-flex items-center text-burnt-orange hover:text-white transition-colors group"
            >
              <svg 
                className="w-5 h-5 mr-2 transform -rotate-180 group-hover:-translate-x-1 transition-transform" 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
              </svg>
              Back to Services
            </Link>
          </div>
        </div>
      </section>

      {/* Service Details */}
      <section className="py-20 bg-dark-gray">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2">
              <motion.div
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
                className="mb-12"
              >
                <h2 className="text-3xl font-bold text-white mb-6">About This Service</h2>
                <p className="text-gray-300 mb-6">{service.detailedDescription}</p>
                
                <h3 className="text-2xl font-semibold text-white mt-10 mb-4">Our Process</h3>
                <ul className="space-y-3 mb-8">
                  {service.process.map((step, index) => (
                    <li key={index} className="flex items-start">
                      <span className="text-burnt-orange mr-3">0{index + 1}.</span>
                      <span className="text-gray-300">{step}</span>
                    </li>
                  ))}
                </ul>

                <h3 className="text-2xl font-semibold text-white mt-10 mb-4">Key Benefits</h3>
                <ul className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
                  {service.benefits.map((benefit, index) => (
                    <li key={index} className="flex items-start">
                      <svg className="h-5 w-5 text-burnt-orange mr-2 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      <span className="text-gray-300">{benefit}</span>
                    </li>
                  ))}
                </ul>
              </motion.div>
            </div>

            <div>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.2 }}
                className="bg-gray-900/50 rounded-xl p-8 border border-gray-800 sticky top-8"
              >
                <h3 className="text-2xl font-bold text-white mb-6">Service Details</h3>
                
                <div className="mb-8">
                  <h4 className="text-lg font-semibold text-white mb-3">What's Included</h4>
                  <ul className="space-y-2">
                    {service.features.map((feature, index) => (
                      <li key={index} className="flex items-start">
                        <svg className="h-5 w-5 text-burnt-orange mr-2 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                        <span className="text-gray-300">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="pt-6 border-t border-gray-800">
                  <p className="text-gray-300 mb-6">Ready to get started with our {service.title} service? Contact us today to discuss your project and get a personalized quote.</p>
                  <Link 
                    to="/contact" 
                    className="w-full inline-flex justify-center items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-burnt-orange hover:bg-burnt-orange/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-burnt-orange transition-colors"
                  >
                    Contact Us Today
                  </Link>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-dark-gray to-gray-900">
        <div className="container mx-auto px-4 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">Ready to Bring Your Vision to Life?</h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto mb-8">
              Contact us today to discuss your project and let's create something amazing together.
            </p>
            <Link 
              to="/contact" 
              className="inline-flex items-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-burnt-orange hover:bg-burnt-orange/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-burnt-orange transition-colors"
            >
              Get Started
              <svg className="ml-2 -mr-1 w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </Link>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default ServiceDetail;
